document.addEventListener('DOMContentLoaded', function() {
    // Make sure GSAP is loaded
    if (typeof gsap === 'undefined') {
        console.error('GSAP is required for hamburger menu animations');
        return;
    }

    // Get elements
    const hamburgerBtn = document.getElementById('nav-toggle');
    const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
    const mobileMenuItems = document.querySelectorAll('.mobile-menu-list li');
    const mobileMenuLinks = document.querySelectorAll('.mobile-menu-list a');
    const body = document.body;
    
    let isMenuOpen = false;

    // Set initial states
    gsap.set(mobileMenuOverlay, {
        x: '-100%',
        opacity: 0,
        visibility: 'hidden'
    });
    
    gsap.set(mobileMenuItems, {
        opacity: 0,
        y: 30
    });

    // Hamburger button click handler
    hamburgerBtn.addEventListener('click', function(e) {
        e.preventDefault();
        toggleMobileMenu();
    });

    // Mobile menu link click handler
    mobileMenuLinks.forEach(link => {
        link.addEventListener('click', function() {
            closeMobileMenu();
        });
    });

    // Close menu when clicking outside
    mobileMenuOverlay.addEventListener('click', function(e) {
        if (e.target === mobileMenuOverlay) {
            closeMobileMenu();
        }
    });

    // Close menu on escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && isMenuOpen) {
            closeMobileMenu();
        }
    });

    // Toggle mobile menu function
    function toggleMobileMenu() {
        if (isMenuOpen) {
            closeMobileMenu();
        } else {
            openMobileMenu();
        }
    }

    // Open mobile menu with GSAP animations
    function openMobileMenu() {
        isMenuOpen = true;
        
        // Add active class to hamburger
        hamburgerBtn.classList.add('active');
        mobileMenuOverlay.classList.add('active');
        
        // Prevent body scroll
        body.classList.add('mobile-menu-open');
        
        // GSAP Timeline for opening animation
        const tl = gsap.timeline();
        
        tl.set(mobileMenuOverlay, {
            visibility: 'visible'
        })
        .to(mobileMenuOverlay, {
            duration: 0.4,
            x: '0%',
            opacity: 1,
            ease: 'power2.out'
        })
        .to(mobileMenuItems, {
            duration: 0.3,
            opacity: 1,
            y: 0,
            stagger: 0.1,
            ease: 'power2.out'
        }, '-=0.2');
    }

    // Close mobile menu with GSAP animations
    function closeMobileMenu() {
        isMenuOpen = false;
        
        // Remove active class from hamburger
        hamburgerBtn.classList.remove('active');
        
        // GSAP Timeline for closing animation
        const tl = gsap.timeline({
            onComplete: () => {
                mobileMenuOverlay.classList.remove('active');
                body.classList.remove('mobile-menu-open');
            }
        });
        
        tl.to(mobileMenuItems, {
            duration: 0.2,
            opacity: 0,
            y: -20,
            stagger: 0.05,
            ease: 'power2.in'
        })
        .to(mobileMenuOverlay, {
            duration: 0.3,
            x: '-100%',
            opacity: 0,
            ease: 'power2.in'
        }, '-=0.1')
        .set(mobileMenuOverlay, {
            visibility: 'hidden'
        });
    }

    const header = document.querySelector('.header');
    
    if (header) {
        gsap.to(header, {
            scrollTrigger: {
                trigger: body,
                start: 'top -50px',
                end: 'bottom top',
                toggleClass: {
                    targets: header,
                    className: 'scrolled'
                }
            }
        });
    }

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            
            if (target) {
                const headerHeight = header ? header.offsetHeight : 0;
                const targetPosition = target.offsetTop - headerHeight;
                
                gsap.to(window, {
                    duration: 1,
                    scrollTo: targetPosition,
                    ease: 'power2.out'
                });
            }
        });
    });

    // Window resize handler to close mobile menu if opened and window is resized to desktop
    window.addEventListener('resize', function() {
        if (window.innerWidth > 768 && isMenuOpen) {
            closeMobileMenu();
        }
    });
});